import { ResponseGenerator } from 'common/type';
import { trimQueryData } from 'helpers/params';
import { call, put, takeLatest } from 'redux-saga/effects';

import { addAccountGrAPI, deleteAccountGrAPI, getAccountGrAPI, getAccountGrDetailAPI, updateAccountGrAPI } from './api';
import {
  filterAccountGr,
  filterAccountGrSuccess,
  filterAccountGrFailure,
  filterAccountGrDrop,
  filterAccountGrDropSuccess,
  getDetailAccountGr,
  getDetailAccountGrSuccess,
  getDetailAccountGrFailure,
  registerAccountGrSuccess,
  registerAccountGrFailure,
  registerAccountGr,
  updateAccountGrSuccess,
  updateAccountGrFailure,
  deleteAccountGrSuccess,
  deleteAccountGrFailure,
  updateAccountGr,
  deleteAccountGr,
} from './slice';
import {
  SearchEntityGroupMasterRequest,
  DetailEntityGroupMasterRequest,
  UpdateEntityGroupMasterRequest,
  DeleteEntityGroupMasterRequest,
} from 'api-types/src/types/entity-group-master';

function* fetchAccountGrMaster({ payload }: { payload: SearchEntityGroupMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(getAccountGrAPI, trimQueryData(payload));
    yield put(filterAccountGrSuccess(response.data));
  } catch (error) {
    yield put(filterAccountGrFailure());
  }
}

function* fetchAccountGrDropMaster({ payload }: { payload: SearchEntityGroupMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(getAccountGrAPI, trimQueryData(payload));
    yield put(filterAccountGrDropSuccess(response.data));
  } catch (error) {
    yield put(filterAccountGrFailure());
  }
}

function* fetchAccountGrDetail({ payload }: { payload: DetailEntityGroupMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(getAccountGrDetailAPI, payload);
    yield put(getDetailAccountGrSuccess(response.data));
  } catch (error: any) {
    yield put(getDetailAccountGrFailure({ message: error?.message }));
  }
}

function* registerAccountGrSaga({ payload }: { payload: UpdateEntityGroupMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(addAccountGrAPI, payload);
    yield put(registerAccountGrSuccess(response));
  } catch (error: any) {
    yield put(registerAccountGrFailure({ message: error?.message }));
  }
}

function* updateAccountGrSaga({ payload }: { payload: UpdateEntityGroupMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(updateAccountGrAPI, payload);
    yield put(updateAccountGrSuccess(response));
  } catch (error: any) {
    yield put(updateAccountGrFailure({ message: error?.message }));
  }
}

function* deleteAccountGrSaga({ payload }: { payload: DeleteEntityGroupMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(deleteAccountGrAPI, payload);
    yield put(deleteAccountGrSuccess(response));
  } catch (error: any) {
    yield put(deleteAccountGrFailure({ message: error?.message }));
  }
}

function* watchAccountGrMaster() {
  yield takeLatest(filterAccountGr, fetchAccountGrMaster);
  yield takeLatest(filterAccountGrDrop, fetchAccountGrDropMaster);
  yield takeLatest(getDetailAccountGr, fetchAccountGrDetail);
  yield takeLatest(registerAccountGr, registerAccountGrSaga);
  yield takeLatest(updateAccountGr, updateAccountGrSaga);
  yield takeLatest(deleteAccountGr, deleteAccountGrSaga);
}

export default watchAccountGrMaster;
